import React from 'react'
import SubmenuItem from '../SubmenuItem'
import SubmenuItemImage from '../SubmenuItemImage'

const MobileNavigationLink = (item) => {
    return (
        <>
            {!item.image.filename && <SubmenuItem {...item}/>}
            {item.image.filename && <SubmenuItemImage {...item}/>}
        </>
    )
}

export default MobileNavigationLink